<template>
  <div>
    <div class="columns is-multiline">
      <b-field class="column is-4" label="Estado">
        <b-select v-model="estado" expanded @input="load"
          ><option value="">Todos los estados</option>
          <option v-for="item in states" :key="item.value" :value="item.value">{{ item.label }}</option></b-select
        >
      </b-field>
      <b-field class="column is-18" label="Buscar">
        <b-input v-model="search" placeholder="Buscar..." type="search" expanded @keydown.native.enter="load" />
        <b-button @click="load" type="is-primary" class="ml-2">Buscar</b-button>
      </b-field>
    </div>
    <b-table
      :data="rows"
      :loading="loading"
      paginated
      backend-pagination
      :total="total"
      :per-page="20"
      @page-change="
        page = $event;
        load();
      "
      striped
    >
      <b-table-column field="id" label="#" v-slot="p">{{ p.row.id }}</b-table-column>
      <b-table-column label="Prospecto" v-slot="p"
        ><strong>{{ p.row.nombre }} {{ p.row.apellido }}</strong
        ><br /><small>{{ p.row.email }} · {{ p.row.telefono }}</small
        ><br /><small>RFC: {{ p.row.rfc }}</small></b-table-column
      >
      <b-table-column label="Categoría / subespecialidad" v-slot="p"
        >{{ p.row.categoria || 'Sin categoría' }}<br /><small>{{ p.row.subespecialidad || 'Sin subespecialidad' }}</small></b-table-column
      >
      <b-table-column label="Disponibilidad" v-slot="p">{{ p.row.circulos_disponibles }} círculos</b-table-column>
      <b-table-column label="Estado" v-slot="p"
        ><b-tag :type="tagType(p.row.estado)">{{ label(p.row.estado) }}</b-tag></b-table-column
      >
      <b-table-column field="acciones" label="Acciones" width="180" v-slot="p">
        <div class="buttons">
          <b-button type="is-primary" size="is-small" icon-left="pencil" @click="edit(p.row)" title="Editar seguimiento"></b-button>
          <b-button type="is-danger" size="is-small" icon-left="delete" @click="discard(p.row.id)" title="Descartar"></b-button>
        </div>
      </b-table-column>
    </b-table>
    <b-modal v-model="modal" has-modal-card trap-focus
      ><div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Seguimiento de prospecto</p>
          <button class="delete" @click="modal = false" />
        </header>
        <section class="modal-card-body">
          <p>
            <strong>{{ form.nombre }} {{ form.apellido }}</strong
            ><br />{{ form.email }}<br /><br />{{ form.mensaje }}
          </p>
          <div class="availability-section my-4">
            <p class="has-text-weight-semibold">Círculos con disponibilidad ({{ form.circulos_disponibles || 0 }})</p>
            <div v-if="form.circulos_disponibles_nombres" class="tags mt-3">
              <b-tag v-for="circle in availableCircleNames(form.circulos_disponibles_nombres)" :key="circle" type="is-success" rounded>{{
                circle
              }}</b-tag>
            </div>
            <p v-else class="has-text-grey mt-2">No hay círculos disponibles actualmente.</p>
          </div>
          <b-field label="Estado"
            ><b-select v-model="form.estado" expanded
              ><option v-for="item in states" :key="item.value" :value="item.value">{{ item.label }}</option></b-select
            ></b-field
          ><b-field label="Notas internas"><b-input v-model="form.notas_internas" type="textarea" /></b-field>
        </section>
        <footer class="modal-card-foot"><b-button type="is-primary" @click="save">Guardar seguimiento</b-button></footer>
      </div></b-modal
    >
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';
export default {
  data: () => ({
    rows: [],
    total: 0,
    page: 1,
    search: '',
    estado: '',
    loading: false,
    modal: false,
    form: {},
    states: [
      { value: 'nuevo', label: 'Nuevo' },
      { value: 'revisado', label: 'Revisado' },
      { value: 'contactando', label: 'Contactando' },
      { value: 'en_proceso', label: 'En proceso' },
      { value: 'finalizado', label: 'Finalizado' },
      { value: 'descartado', label: 'Descartado' },
    ],
  }),
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({ fetch: 'prospects/fetchList', update: 'prospects/save', remove: 'prospects/remove' }),
    async load() {
      this.loading = true;
      await this.fetch({ page: this.page, size: 20, search: this.search, estado: this.estado });
      this.rows = this.$store.state.prospects.list;
      this.total = this.$store.state.prospects.pagination.total || 0;
      this.loading = false;
    },
    label(value) {
      const item = this.states.find((state) => state.value === value);
      return item ? item.label : value;
    },
    availableCircleNames(value) {
      return String(value || '')
        .split(' | ')
        .filter((circle) => circle.trim());
    },
    tagType(value) {
      return {
        nuevo: 'is-info',
        revisado: 'is-link',
        contactando: 'is-warning',
        en_proceso: 'is-primary',
        finalizado: 'is-success',
        descartado: 'is-danger',
      }[value];
    },
    edit(row) {
      this.form = { ...row };
      this.modal = true;
    },
    async save() {
      const response = await this.update(this.form);
      if (response.status) {
        this.modal = false;
        await this.load();
      }
      Swal.fire({ icon: response.status ? 'success' : 'error', title: response.message });
    },
    async discard(id) {
      const confirmation = await Swal.fire({ title: '¿Descartar prospecto?', showCancelButton: true, confirmButtonText: 'Sí, descartar' });
      if (confirmation.isConfirmed) {
        const response = await this.remove(id);
        Swal.fire({ icon: response.status ? 'success' : 'error', title: response.message });
        await this.load();
      }
    },
  },
};
</script>
